// extracted by mini-css-extract-plugin
module.exports = {"inputSearch":"searchComponent_inputSearch__35Qkr","searchSpace":"searchComponent_searchSpace__2THKz","searchButton":"searchComponent_searchButton__2EIRY"};